import { defineStore } from 'pinia'
import { ref } from 'vue'
import NewTag from '@/models/new_tag'

export const useJobTagsStore = defineStore('jobTags', () => {
  const draftTags = ref<NewTag[]>([])

  const setDraftTags = (newDraftJob: NewTag[]) => {
    draftTags.value = newDraftJob
  }

  const clearDraftTags = () => {
    draftTags.value = []
  }

  return {
    draftTags,
    setDraftTags,
    clearDraftTags,
  }
})
